/* AULBERY — Marquee (sections/as-marquee.liquid)
   Marquee engine, moved 1:1 from the section's inline script. Per-instance
   values are read from data-* attributes on [data-as-marquee]. Cloned
   sequences are aria-hidden; shopify:section:unload clears the rebuild
   timers and the window resize listener. Visible behaviour is unchanged. */
(function () {
  function initMq(root) {
    if (!root || root.dataset.asmInit === '1') return;
    root.dataset.asmInit = '1';

    var viewport = root.querySelector('[data-asm-viewport]');
    var track = root.querySelector('[data-asm-track]');
    var seq = root.querySelector('[data-asm-seq]');
    if (!viewport || !track || !seq) return;

    var speedFallback = parseFloat(root.dataset.speedFallback) || 60;
    var speed = parseFloat(root.dataset.speed) || speedFallback; // px per second
    var fill = parseFloat(root.dataset.fill) || 1.5;
    var rebuild1 = parseInt(root.dataset.rebuild1, 10);
    if (isNaN(rebuild1)) rebuild1 = 300;
    var rebuild2 = parseInt(root.dataset.rebuild2, 10);
    if (isNaN(rebuild2)) rebuild2 = 1200;
    var resizeMs = parseInt(root.dataset.resizeMs, 10);
    if (isNaN(resizeMs)) resizeMs = 200;

    var destroyed = false;
    var timers = [];

    function clone(node) {
      var c = node.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      return c;
    }

    function build() {
      if (destroyed) return;
      // strip everything after the first sequence, then re-clone
      var seqs = track.querySelectorAll('.asm-seq');
      for (var i = seqs.length - 1; i > 0; i--) seqs[i].remove();

      var one = seq.offsetWidth;
      if (!one) return;

      // repeat the sequence until it comfortably covers the viewport,
      // then duplicate the whole thing once for the -50% loop
      var needed = Math.max(2, Math.ceil((viewport.offsetWidth * fill) / one));
      for (var n = 1; n < needed; n++) {
        track.appendChild(clone(seq));
      }
      var half = track.scrollWidth;
      for (var m = 0; m < needed; m++) {
        track.appendChild(clone(track.children[m]));
      }
      track.style.animationDuration = (half / speed) + 's';
    }

    if (root.dataset.tapPause === '1') {
      root.addEventListener('click', function () {
        root.classList.toggle('is-paused');
      });
    }

    build();
    timers.push(setTimeout(build, rebuild1));
    timers.push(setTimeout(build, rebuild2));
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(build);
    }
    var rt;
    function onResize() {
      clearTimeout(rt);
      rt = setTimeout(build, resizeMs);
    }
    window.addEventListener('resize', onResize);

    root._asmCleanup = function () {
      destroyed = true;
      timers.forEach(function (t) { clearTimeout(t); });
      timers = [];
      clearTimeout(rt);
      window.removeEventListener('resize', onResize);
    };
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-as-marquee]');
    Array.prototype.forEach.call(roots, initMq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var roots = e.target ? e.target.querySelectorAll('[data-as-marquee]') : [];
    Array.prototype.forEach.call(roots, function (root) {
      if (root._asmCleanup) root._asmCleanup();
    });
  });
})();

